import { storeRegister } from 'piri/utils';

import mutations from './mutations';
import moduleName from './moduleName';

const state = {
  files: {},
  fileUploaders: {},
};

export default {
  namespaced: true,
  ...storeRegister,
  key: moduleName,
  state,
  mutations,
};
